// src/pages/AddNotification.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import colors from "../Constants/colors";

function AddNotification() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [deleteDate, setDeleteDate] = useState("");
  const [attachFile, setAttachFile] = useState(null);
const [editingId, setEditingId] = useState(null);

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  const [className, setClassName] = useState("");
  const [sectionName, setSectionName] = useState("");
const [classId, setClassId] = useState("");
const [sectionId, setSectionId] = useState("");

  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState([]);

  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";
  const inputStyle =
    "border rounded-lg px-3 py-2 outline-none !text-[14px] focus:ring-2 focus:ring-blue-500";

  // 🔹 Fetch teacher classes
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const teacherRaw = localStorage.getItem("teacher");
        const sessionId = localStorage.getItem("currentSessionId");
        if (!teacherRaw || !sessionId) return;

        const teacherId = JSON.parse(teacherRaw).id;

        const teacherRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
          { params: { sessionId } }
        );

        const teacherName = `${teacherRes.data.firstName} ${teacherRes.data.lastName}`;

        const classRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getTeacherClasses/${teacherName}`,
          { params: { sessionId } }
        );

        setClasses(classRes.data || []);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    fetchClasses();
  }, []);

  // 🔹 Class change → load sections
const handleClassChange = (e) => {
  const selectedClass = e.target.value;

  const filtered = classes.filter(c => c.className === selectedClass);

  setClassName(selectedClass);
  setSectionName("");
  setSectionId("");

  // ✅ classId from first matching row
  if (filtered.length > 0) {
    setClassId(filtered[0].classId);
  }

  const filteredSections = filtered.map(c => c.sectionName);
  setSections([...new Set(filteredSections)]);
};

const fetchLedger = async () => {
  if (!classId || !sectionId) return;

  try {
    const sessionId = localStorage.getItem("currentSessionId");

    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/notificationsClasswise/getNotifications`,
      {
        params: {
          sessionId,
          classId,
          sectionId,
        },
      }
    );

    setLedger(res.data || []);
  } catch (err) {
    console.error("FETCH ERROR:", err);
  }
};

useEffect(() => {
  if (!className || !sectionName) return;
  fetchLedger();
}, [className, sectionName]);





  // 🔹 Submit notification
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!className || !sectionName) {
      alert("Please select class & section");
      return;
    }

    const sessionId = localStorage.getItem("currentSessionId");
    if (!sessionId) {
      alert("Session missing");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    formData.append("deleteDate", deleteDate);
formData.append("classId", classId);
formData.append("sectionId", sectionId);

formData.append("sendTo", "classwise");
    formData.append("sessionId", sessionId);

    if (attachFile) formData.append("file", attachFile);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/notificationsClasswise/createClasswiseNotification`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      alert(editingId ? " Notification Updated" : " Notification Added");

    
//  After success
await fetchLedger(); // ✅ reload ledger from backend


      // reset form
      setTitle("");
      setContent("");
      setDeleteDate("");
      setAttachFile(null);
setEditingId(null);

    } catch (error) {
      console.error("CREATE ERROR:", error.response?.data || error);
      alert(error.response?.data?.message || "Error creating notification");
    } finally {
      setLoading(false);
    }
  };
const getClassNameById = (id) => {
  const cls = classes.find((c) => c.classId === id);
  return cls?.className || "-";
};

const getSectionNameById = (classId, sectionId) => {
  const row = classes.find(
    (c) => c.classId === classId && c.sectionId === sectionId
  );
  return row?.sectionName || "-";
};





  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="font-bold text-[18px] mb-4">Add New Notification</h1>

      {/* ================= FORM ================= */}
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-md rounded-lg p-6 border space-y-6"
      >
        {/* Class */}
        <div className="flex flex-col">
          <label className={labelStyle}>Class</label>
          <select
            value={className}
            onChange={handleClassChange}
            className={inputStyle}
            required
          >
            <option value="">Select Class</option>
            {[...new Set(classes.map((c) => c.className))].map((cls) => (
              <option key={cls} value={cls}>
                {cls}
              </option>
            ))}
          </select>
        </div>

        {/* Section */}
        <div className="flex flex-col">
          <label className={labelStyle}>Section</label>
          <select
  value={sectionName}
  onChange={(e) => {
    const secName = e.target.value;

    const row = classes.find(
      c => c.className === className && c.sectionName === secName
    );

    setSectionName(secName);
    setSectionId(row?.sectionId || "");
  }}
  className={inputStyle}
  required
  disabled={!className}
>

            <option value="">Select Section</option>
            {sections.map((sec) => (
              <option key={sec} value={sec}>
                {sec}
              </option>
            ))}
          </select>
        </div>

        {/* Title */}
        <div className="flex flex-col">
          <label className={labelStyle}>Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className={inputStyle}
            required
          />
        </div>

        {/* Content */}
        <div className="flex flex-col">
          <label className={labelStyle}>Content</label>
          <textarea
            rows={4}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className={`${inputStyle} min-h-[100px]`}
            required
          />
        </div>

        {/* Delete Date */}
        <div className="flex flex-col">
          <label className={labelStyle}>Delete Date</label>
          <input
            type="date"
            value={deleteDate}
            onChange={(e) => setDeleteDate(e.target.value)}
            className={inputStyle}
            required
          />
        </div>

        {/* File */}
        <div className="flex flex-col">
          <label className={labelStyle}>Attach File (Optional)</label>
          <input type="file" onChange={(e) => setAttachFile(e.target.files[0])} />
        </div>

        {/* Button */}
        <div className="flex justify-end">
          <button
            type="submit"
            disabled={loading}
            style={{ background: colors.gradientPrimary }}
            className="px-6 py-2 rounded-lg text-white font-semibold flex gap-2 items-center disabled:opacity-60"
          >
           {loading ? (
  <>
    <i className="fas fa-spinner fa-spin"></i>{" "}
    {editingId ? "Updating..." : "Adding..."}
  </>
) : (
  editingId ? "Update Notification" : "Add Notification"
)}

          </button>
        </div>
      </form>

      {/* ================= LEDGER ================= */}
      {/* ================= LEDGER ================= */}
      
<div className="mt-10">
  <h2 className="font-bold text-[18px] mb-3">Notification Ledger</h2>

  {ledger.length === 0 ? (
    <p className="text-gray-500">No notifications added yet.</p>
  ) : (
    <div className="overflow-x-auto">
      <table className="w-full border border-gray-300 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-3 py-2">Class</th>
            <th className="border px-3 py-2">Section</th>
            <th className="border px-3 py-2">Title</th>
            <th className="border px-3 py-2">Content</th>
            <th className="border px-3 py-2">Delete Date</th>
            <th className="border px-3 py-2">Attachment</th>
            <th className="border px-3 py-2">Actions</th>
          </tr>
        </thead>

        <tbody>
          {ledger.map((item) => (
            <tr key={item._id} className="text-center hover:bg-gray-50">
              {/* ✅ Class */}
              <td className="border px-2 py-2 font-medium">{getClassNameById(item.classId)}</td>
<td className="border px-2 py-2">{getSectionNameById(item.classId, item.sectionId)}</td>




              {/* ✅ Title */}
              <td className="border px-2 py-2 font-semibold">
                {item.title}
              </td>

              {/* ✅ Content */}
              <td className="border px-2 py-2 max-w-[300px] truncate">
                {item.content}
              </td>

              {/* ✅ Delete Date */}
              <td className="border px-2 py-2">
                {item.deleteDate
                  ? new Date(item.deleteDate).toLocaleDateString()
                  : "-"}
              </td>

              {/* ✅ Attachment */}
              <td className="border px-2 py-2">
                {item.attachFile ? (
                  <a
                    href={item.attachFile}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline font-medium"
                  >
                    View
                  </a>
                ) : (
                  <span className="text-gray-400">No File</span>
                )}
              </td>

              {/* ✅ Actions */}
              <td className="border px-2 py-2">
                <div className="flex justify-center gap-2">
                  <button
                    className="px-3 py-1 text-sm bg-yellow-500 hover:bg-yellow-600 text-white rounded"
                    onClick={() => {
  // 1️⃣ Fill basic fields
  setTitle(item.title);
  setContent(item.content);
  setDeleteDate(item.deleteDate?.split("T")[0]);
setEditingId(item._id);

  // 2️⃣ Find class row using IDs
  const classRow = classes.find(
    (c) => c.classId === item.classId
  );

  if (!classRow) return;

  // 3️⃣ Set class
  setClassName(classRow.className);
  setClassId(classRow.classId);

  // 4️⃣ Load sections for that class
  const classSections = classes.filter(
    (c) => c.classId === item.classId
  );

  const uniqueSections = [
    ...new Set(classSections.map((c) => c.sectionName)),
  ];

  setSections(uniqueSections);

  // 5️⃣ Set section AFTER sections exist
  const sectionRow = classSections.find(
    (c) => c.sectionId === item.sectionId
  );

  setSectionName(sectionRow?.sectionName || "");
  setSectionId(sectionRow?.sectionId || "");
}}



                  >
                    Edit
                  </button>

                  <button
                    className="px-3 py-1 text-sm bg-red-500 hover:bg-red-600 text-white rounded"
                    onClick={async () => {
                      if (!window.confirm("Delete this notification?")) return;

                      try {
                        await axios.delete(
                          `${process.env.REACT_APP_API_BASE_URL}/api/notificationsClasswise/deleteClasswiseNotification/${item._id}`
                        );
                        setLedger((prev) =>
                          prev.filter((n) => n._id !== item._id)
                        );
                      } catch (err) {
                        alert("Delete failed");
                      }
                    }}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}
</div>

    </div>
  );
}

export default AddNotification;
